import styled from 'styled-components'

const StyledHireView = styled.div``

export default StyledHireView
